import styles from './styles';

export default function ThumbnailButtons({
  pageCount,
  slidePage,
  setSlidePage,
}: {
  pageCount: number;
  slidePage: number;
  setSlidePage: React.Dispatch<React.SetStateAction<number>>;
}): JSX.Element {
  function handleLeftCarouselClick(): void {
    if (slidePage === 0) setSlidePage(pageCount);
    // eslint-disable-next-line no-return-assign, no-param-reassign
    else setSlidePage((val: number) => (val -= 1));
  }

  function handleRightCarouselClick(): void {
    if (slidePage < pageCount) {
      // eslint-disable-next-line no-return-assign, no-param-reassign
      setSlidePage((val: number) => (val += 1));
    } else if (slidePage === pageCount) {
      setSlidePage(0);
    }
  }

  return (
    <>
      <div
        data-testid="left-carousel-button"
        className="left-carousel-button"
        onClick={handleLeftCarouselClick}
      />
      <div
        data-testid="right-carousel-button"
        className="right-carousel-button"
        onClick={handleRightCarouselClick}
      />
      <style>{styles}</style>
    </>
  );
}
